<template>
  <div class="view_box">
    <div class="view_top">
      <div class="title">{{ title }}</div>
      <div class="handle">
        <slot name="handle"></slot>
      </div>
    </div>
    <div class="view_content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
    };
  },
  methods: {
    init() {
      this.title = this.$route.meta.name || "";
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.view_box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .view_top {
    width: 100%;
    height: 46px;
    display: flex;
    justify-content: space-between;
    .title {
      font-size: 20px;
      color: $hei;
      font-weight: 500;
    }
  }
  .view_content {
    background: #fff;
    width: 100%;
    flex: 1;
    height: 0;
    overflow: overlay;
    box-shadow: 0px 2px 3px 1px rgba(7, 59, 178, 0.1);
  }
}
</style>